import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { WHBABTEC_MAINTENANCE_MODE_ACTIVE } from '@whbabtec-types';
import { AuthService } from '../services/auth.service';
import { LanguageService } from '../services/language.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private languageService: LanguageService,
    private router: Router
  ) {}

  public async canActivate(): Promise<boolean> {
    if (WHBABTEC_MAINTENANCE_MODE_ACTIVE) {
      this.router.navigate([
        `/${this.languageService.getCurrentLanguage()}/maintenance`,
      ]);
      return false;
    }

    await this.authService.init();

    if (this.authService.isLoggedIn()) {
      return true;
    }

    const refreshed = await this.authService.tryRefreshToken();
    if (refreshed) {
      return true;
    }

    this.authService.logout();
    return false;
  }
}
